function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(.165)"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M15.7384336,4.88023632 C15.7384336,4.08488107 15.0978575,3.44011824 14.3076669,3.44011824 L5.72306675,3.44011824 L4.71199163,2.42147471 C4.44353833,2.15143986 4.07949137,1.99982707 3.69996266,2.00000015 L1.43076669,2.00000015 C0.640576066,2.00000015 2.66453526e-15,2.64476298 2.66453526e-15,3.44011824 L2.66453526e-15,13.5209449 C2.66453526e-15,14.3163001 0.640576066,14.9610629 1.43076669,14.9610629 L14.3076669,14.9610629 C15.0978575,14.9610629 15.7384336,14.3163001 15.7384336,13.5209449 L15.7384336,4.88023632 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    className: "icon",
    style: {
      "height": "1em",
      "width": "0.94118em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/folder.e90727b0.svg";
export { SvgComponent as ReactComponent };